import { z } from 'zod';

const PaymentNodeMetaModel = z.object({
  position: z.object({ x: z.number(), y: z.number() }),
  nodeId: z.string().uuid(),
});

export const PaymentNodesMetaModel = PaymentNodeMetaModel.array();

export const PaymentNodeMetaFormSchema = PaymentNodeMetaModel.pick({
  position: true,
  nodeId: true,
});
